import { render, staticRenderFns } from "./PaperCard.vue?vue&type=template&id=143e747e&scoped=true&"
import script from "./PaperCard.vue?vue&type=script&lang=js&"
export * from "./PaperCard.vue?vue&type=script&lang=js&"
import style0 from "./PaperCard.vue?vue&type=style&index=0&id=143e747e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e747e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143e747e')) {
      api.createRecord('143e747e', component.options)
    } else {
      api.reload('143e747e', component.options)
    }
    module.hot.accept("./PaperCard.vue?vue&type=template&id=143e747e&scoped=true&", function () {
      api.rerender('143e747e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/components/PaperCard.vue"
export default component.exports